module.exports = __webpack_public_path__ + "img/green-flacon.7dd6de45.svg";